export default __webpack_public_path__ + "static/media/over-weight.cd7a3f3e.svg";